document.addEventListener('DOMContentLoaded', () => {
  const logoWrapper = document.querySelector('.header__heading-logo-wrapper');
  const headerWrapper = document.querySelector('.header-wrapper.gradient');
  const animatedElements = [
    logoWrapper,
    document.querySelector('.header__search'),
    document.querySelector('.header__icon.header__icon--account'),
    document.querySelector('.header__icon.header__icon--cart'),
  ].filter(Boolean);

  if (!headerWrapper) return;

  let lastScrollTop = 0;
  let isScrollingDown = false;

  const getAnnouncementBarHeight = () => {
    const announcementBar = document.querySelector('.announcement-bar-section');
    if (!announcementBar) return 0;
    if (announcementBar.offsetHeight === 0) return 0;
    return announcementBar.offsetHeight;
  };

  const updateHeaderPosition = () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const announcementBarHeight = getAnnouncementBarHeight();
    const newTop = Math.max(0, announcementBarHeight - currentScrollTop);
    headerWrapper.style.top = `${newTop}px`;
  };

  const setHeaderTransparency = (isTransparent) => {
    headerWrapper.style.backgroundColor = isTransparent ? 'transparent' : '#f4f4f4';
  };

  const applyStateFromScrollPosition = () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    updateHeaderPosition();

    if (currentScrollTop > 0) {
      // On refresh away from top, keep hidden-state visuals consistent.
      isScrollingDown = true;
      animatedElements.forEach((element) => element.classList.add('header__hidden'));
      headerWrapper.classList.add('header-wrapper--hidden');
      setHeaderTransparency(true);
    } else {
      isScrollingDown = false;
      animatedElements.forEach((element) => element.classList.remove('header__hidden'));
      headerWrapper.classList.remove('header-wrapper--hidden');
      setHeaderTransparency(true);
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  };

  window.addEventListener('scroll', () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    updateHeaderPosition();

    if (currentScrollTop > lastScrollTop) {
      if (!isScrollingDown) {
        isScrollingDown = true;
        animatedElements.forEach((element) => element.classList.add('header__hidden'));
        headerWrapper.classList.add('header-wrapper--hidden');
        setHeaderTransparency(true);
      }
    } else if (isScrollingDown || currentScrollTop === 0) {
      isScrollingDown = false;
      animatedElements.forEach((element) => element.classList.remove('header__hidden'));
      headerWrapper.classList.remove('header-wrapper--hidden');
      setHeaderTransparency(currentScrollTop === 0);
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  });

  applyStateFromScrollPosition();
  window.addEventListener('pageshow', applyStateFromScrollPosition);
  window.addEventListener('resize', updateHeaderPosition);
});
